import React, { useCallback, useMemo } from 'react';

import { IconButton } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  LastPage,
  FirstPage,
  KeyboardArrowRight,
  KeyboardArrowLeft,
} from '@material-ui/icons';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

export function TablePaginationActions({
  count,
  page,
  rowsPerPage,
  onPageChange,
}) {
  const classes = useStyles();
  const theme = useTheme();

  const isDirection = useMemo(() => theme.direction !== 'ltr', [
    theme.direction,
  ]);

  const handleFirstPage = useCallback(() => {
    onPageChange(1);
  }, []);

  const handlePreviwPage = useCallback(() => {
    onPageChange(Number(page - 1));
  }, [page]);

  const handleNextPage = useCallback(() => {
    onPageChange(Number(page + 1));
  }, [page]);

  const handleLastPage = useCallback(() => {
    onPageChange(Math.max(0, Math.ceil(count / rowsPerPage)));
  }, [count, rowsPerPage]);

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPage}
        disabled={page === 1}
        aria-label="first page"
      >
        {isDirection ? <LastPage /> : <FirstPage />}
      </IconButton>

      <IconButton
        onClick={handlePreviwPage}
        disabled={page === 1}
        aria-label="previous page"
      >
        {isDirection ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>

      <IconButton
        onClick={handleNextPage}
        disabled={page >= Math.ceil(count / rowsPerPage)}
        aria-label="next page"
      >
        {isDirection ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>

      <IconButton
        onClick={handleLastPage}
        disabled={page >= Math.ceil(count / rowsPerPage)}
        aria-label="last page"
      >
        {isDirection ? <FirstPage /> : <LastPage />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};
